import useOnFocusInsideChange from 'js/hooks/use-on-focus-inside-change';
import useOutsideClick from 'js/hooks/use-outside-click';

import DatesMoreLink from './DatesMoreLink';

import { IDatesMoreLink } from 'source/NFR.types';

interface IDatesMoreLinkListProps {
  dates: IDatesMoreLink[];
  isOpen?: boolean;
  toggleAccordion: () => void;
}

const DatesMoreLinkList: React.FC<IDatesMoreLinkListProps> = ({ dates, isOpen, toggleAccordion }) => {
  const listRef = useOnFocusInsideChange(isInside => !isInside && toggleAccordion(), isOpen);

  useOutsideClick(listRef, () => isOpen && toggleAccordion());

  return (
    <ul className="dates-more-link-list" ref={listRef as React.RefObject<HTMLUListElement>}>
      {dates?.map((date, index) => (
        <DatesMoreLink {...date} key={`${date.link?.url ?? ''}-${index}`} isOpen={isOpen} />
      ))}
    </ul>
  );
};

DatesMoreLinkList.displayName = 'DatesMoreLinkList';

export default DatesMoreLinkList;
